import styled from "styled-components";

export const CommentStatusButtonWrapper = styled.button`
  cursor: pointer;
  outline: none;
`;
